import { Profile, ProfileInner } from 'app/Pages/common/styles';
import React from 'react';
import {
  ProfileBodyStyled,
  TabsContainerStyled,
  TabsControlIconNextStyled,
  TabsControlIconPrevStyled,
  TabsStyled
} from 'app/Pages/common/Profile/styles';
import { TError, TStandardSectionStep } from 'models';
import { IBrokerProps, TBroker } from 'app/Pages/common';
import { AxiosError } from 'axios';
import { cloneObject, generateTabs, translate } from 'utils';
import { ProfileBody } from './body';

const scrollTo = 100;



interface IProps {
  step: TStandardSectionStep,
  updateStep: (section: string) => void,
  activeTab?: string,
  brokerId: string,
  profile: TBroker | null,
  dataStatus: string,
  errors: TError[],
  handlePatchBroker: (selectedBroker: TBroker, onError?: (errors: AxiosError) => void, onSuccess?: () => void, shouldDrawerClose?: boolean) => void,
}

export const BrokerProfile = ({
  step,
  updateStep,
  activeTab = 'agents',
  brokerId,
  profile,
  handlePatchBroker,
  dataStatus,
  errors
}: IProps) => {

  const TABS = [
    {
      key: 'agents',
      title: translate({ key: 'master.broker.agent.title' }),
    },
    {
      key: 'structure',
      title: translate({ key: 'master.broker.structure.title' }),
    },
    {
      key: 'paymentMethods',
      title: translate({ key: 'common.payment_methods.title' }),
    },
    {
      key: 'generalSettings',
      title: translate({ key: 'master.broker.general_settings.title' }),
    },
    {
      key: 'documents',
      title: translate({ key: 'master.broker.documents.title' }),
    },
    {
      key: 'sortingSettings',
      title: translate({ key: 'master.broker.sorting_settings.title' }),
    },
    {
      key: 'cepik',
      title: translate({ key: 'master.broker.cepik.title' }),
    },
    {
      key: 'gdpr_documents',
      title: translate({ key: 'master.gdpr_documents.title' }),
    },
  ];

  const scrollableList = document.querySelector<HTMLElement>('.qmt-ui-tabs');

  const updateActiveTab = (tab: string) => {
    if (tab !== activeTab) {
      updateStep(`broker/profile/${brokerId}/${tab}`);
    }
  };

  const onSaveBroker = (data: TBroker, onError?: (errors: AxiosError) => void, onSuccess?: () => void) => {
    profile && handlePatchBroker({
      ...data
    }, onError, onSuccess, true);
  };

  const onSubmitPaymentMethods = (paymentMethods: Record<string, string[]>, onError: (errors: AxiosError) => void, onSuccess: () => void) => {
    if (profile) {
      const profileToSave = cloneObject(profile);

      if (!Object.keys(paymentMethods).length) {
        profileToSave.props.payment_methods = null;
      } else {
        profileToSave.props.payment_methods = paymentMethods;
      }

      onSaveBroker(profileToSave, onError, onSuccess);
    }
  };

  const onSubmitProps = (props: IBrokerProps, onError: (errors: AxiosError) => void, onSuccess: () => void) => {
    if (profile) {
      const profileToSave = cloneObject(profile);
      profileToSave.props = props;

      onSaveBroker(profileToSave, onError, onSuccess);
    }
  };

  const startScroll = (shift: number) => {
    if (scrollableList) {
      scrollableList.scrollLeft += shift;
    }
  };

  return (
    <Profile step={step}>
      <ProfileInner>
        <TabsContainerStyled>
          <TabsControlIconPrevStyled icon="arrow_down" onClick={() => startScroll(-scrollTo)} />
          <TabsStyled items={generateTabs(TABS, activeTab, updateActiveTab)} />
          <TabsControlIconNextStyled icon="arrow_down" onClick={() => startScroll(scrollTo)} />
        </TabsContainerStyled>
        <ProfileBodyStyled>
          <ProfileBody
            brokerId={brokerId}
            activeTab={activeTab}
            profile={profile}
            dataStatus={dataStatus}
            errors={errors}
            onSubmitPaymentMethods={onSubmitPaymentMethods}
            onSubmitProps={onSubmitProps}
          />
        </ProfileBodyStyled>
      </ProfileInner>
    </Profile>
  );
};

